import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-next",
  "use": "icon-search-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search-next\">\n<circle cx=\"11\" cy=\"11\" r=\"5\" stroke=\"#42526E\" stroke-width=\"2\" />\n<path d=\"M15 15C16.3668 16.3668 16.6332 16.6332 18 18\" stroke=\"#42526E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol